var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 1.5h3.3a.8.8 0 0 1 .8.8v13.4a.8.8 0 0 1-.8.8h-15a.8.8 0 0 1-.8-.8V2.3a.8.8 0 0 1 .8-.8h3.3V-.2h1.7v1.7h5V-.2h1.7v1.7Zm2.5 6.7H3.3v6.6h13.4V8.2Zm-4.2-5h-5v1.6H5.8V3.2H3.3v3.3h13.4V3.2h-2.5v1.6h-1.7V3.2ZM5 9.8h1.7v1.7H5V9.8Zm4.2 0h1.6v1.7H9.2V9.8Zm4.1 0H15v1.7h-1.7V9.8Z",
    fill: "currentColor"
  })));
};

export default SvgCalendar;